module.exports = __webpack_public_path__ + "static/media/List.ee879c16.PNG";